import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneDeparture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#airplane-departure_svg__a)">
      <path d="M21 22H3c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1M5.97 16.64a.97.97 0 0 1-.78-.38L2.59 13c-.54-.69-.73-1.6-.49-2.44s.87-1.52 1.69-1.82c.69-.25 1.43-.22 2.09.09l1.64.76.32-.12-2.39-3.29c-.49-.68-.63-1.52-.39-2.32.25-.8.83-1.42 1.62-1.7a2.66 2.66 0 0 1 2.6.46l5.22 4.42 3.36-1.22c.77-.28 1.61-.24 2.35.1.75.35 1.31.96 1.59 1.74s.25 1.61-.1 2.35c-.35.75-.96 1.31-1.74 1.59L6.31 16.58c-.11.04-.23.06-.34.06m-1.24-6.07a.714.714 0 0 0-.7.53.72.72 0 0 0 .13.65l2.14 2.7 12.99-4.73c.56-.2.85-.82.64-1.38-.2-.56-.82-.85-1.38-.64l-3.9 1.42c-.34.12-.71.05-.99-.18L7.99 4.15a.63.63 0 0 0-.63-.11c-.26.09-.36.3-.39.41-.04.11-.07.34.09.56l3.17 4.37c.18.25.24.58.15.88s-.32.54-.61.65l-1.95.71a1 1 0 0 1-.76-.03l-2.01-.94a.7.7 0 0 0-.31-.07z" />
    </g>
    <defs>
      <clipPath id="airplane-departure_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirplaneDeparture;
